import { render } from "./Index-main.vue?vue&type=template&id=70480edc"
import script from "./Index-main.vue?vue&type=script&lang=js"
export * from "./Index-main.vue?vue&type=script&lang=js"

import "./Index-main.vue?vue&type=style&index=0&id=70480edc&lang=css"
import "./Index-main.vue?vue&type=style&index=1&id=70480edc&lang=scss"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__